// extracted by mini-css-extract-plugin
module.exports = {"followButton":"styles_followButton__2O2FZ","isFollowed":"styles_isFollowed__KUxEE"};